import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-363">
      <div className="max-w-5xl mx-auto" data-id="element-364">
        <div className="max-w-2xl mx-auto mb-12" data-id="element-365">
          <div className="bg-black border border-[#00C853]/30 rounded-2xl p-6" data-id="element-366">
            <h3 className="text-[#00C853] text-xl font-black mb-5" data-id="element-367">
              🇮🇹 A1 → C2 — 6 TOMOS
            </h3>
            <div className="space-y-4" data-id="element-368">
              <div className="flex items-center gap-3 text-white" data-id="element-369">
                <span className="text-xl" data-id="element-370">📘</span>
                <div className="flex-1" data-id="element-371">
                  <span className="font-bold" data-id="element-372">Tomo 1 — A1 · Base Pronta</span>
                  <span className="text-gray-300" data-id="element-373">
                    {' '}
                    Alfabeto, saludos, artículos, Presente, ESSERE & AVERE.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-374">
                <span className="text-xl" data-id="element-375">📗</span>
                <div className="flex-1" data-id="element-376">
                  <span className="font-bold" data-id="element-377">Tomo 2 — A2 · Connessione</span>
                  <span className="text-gray-300" data-id="element-378">
                    {' '}
                    Passato Prossimo, Imperfetto, pronomi diretti.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-379">
                <span className="text-xl" data-id="element-380">📙</span>
                <div className="flex-1" data-id="element-381">
                  <span className="font-bold" data-id="element-382">Tomo 3 — B1 · Sviluppo</span>
                  <span className="text-gray-300" data-id="element-383">
                    {' '}
                    Futuro, Condizionale, Periodo Ipotetico 1 y 2.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-384">
                <span className="text-xl" data-id="element-385">📕</span>
                <div className="flex-1" data-id="element-386">
                  <span className="font-bold" data-id="element-387">Tomo 4 — B2 · Opinione</span>
                  <span className="text-gray-300" data-id="element-388">
                    {' '}
                    Congiuntivo completo, Passiva, Discorso Indiretto.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-389">
                <span className="text-xl" data-id="element-390">📓</span>
                <div className="flex-1" data-id="element-391">
                  <span className="font-bold" data-id="element-392">Tomo 5 — C1/C2 · Maestria</span>
                  <span className="text-gray-300" data-id="element-393">
                    {' '}
                    Análisis literario, registro académico, certificaciones.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-394">
                <span className="text-xl" data-id="element-395">📔</span>
                <div className="flex-1" data-id="element-396">
                  <span className="font-bold" data-id="element-397">
                    Tomo 6 — Kit Eval. · Valutazione
                  </span>
                  <span className="text-gray-300" data-id="element-398">
                    {' '}
                    24 verifiche, Placement Test, Solucionario Maestro.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00C853]/5 border border-[#00C853]/30 rounded-2xl p-8 text-center" data-id="element-399">
          <h3 className="text-[#00C853] text-xl font-black mb-6" data-id="element-400">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-401">
            <div className="flex items-start gap-2 text-left" data-id="element-402">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-403">✅</span>
              <span className="text-white text-sm" data-id="element-404">
                Planificación anual lista para entregar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-405">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-406">✅</span>
              <span className="text-white text-sm" data-id="element-407">
                14 Unidades Didácticas completas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-408">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-409">✅</span>
              <span className="text-white text-sm" data-id="element-410">
                Actividades fotocopiables
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-411">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-412">✅</span>
              <span className="text-white text-sm" data-id="element-413">
                Verifiche + criterios de corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-414">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-415">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-416">
                Solucionario completo con justificaciones
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-417">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-418">✅</span>
              <span className="text-white text-sm" data-id="element-419">
                Errores de interferencia español-italiano
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-420">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-421">✅</span>
              <span className="text-white text-sm" data-id="element-422">
                Conexión cultural Italia-Argentina
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-423">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-424">✅</span>
              <span className="text-white text-sm" data-id="element-425">
                100% alineado al MCER vigente
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}